import { render, staticRenderFns } from "./Classroom_new.vue?vue&type=template&id=4e8dbb7e&scoped=true"
import script from "./Classroom_new.vue?vue&type=script&lang=js"
export * from "./Classroom_new.vue?vue&type=script&lang=js"
import style0 from "./Classroom_new.vue?vue&type=style&index=0&id=4e8dbb7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8dbb7e",
  null
  
)

export default component.exports